module.exports = __webpack_public_path__ + "static/media/DSC_0195 (2).92e05eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0195 (2).jpg
// module id = 565
// module chunks = 0